<div class="ppl-mt20">
    <form nz-form nz-row [formGroup]="authAllocationForm" class="ppl-p0">
        <div class="row" style="width: 100%; margin-left: 0">
            @if(isAttrAvailable('orgId')){
            <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="orgId"
                        class="ppl-form-label">{{getAttributes('orgId').label}}
                        @if(getAttributes('orgId').mandatory === 'Y'){
                        <span [attr.aria-label]="'Required'">*</span>
                        }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                        <div nz-tooltip [nzTooltipTitle]="getAttributes('orgId')?.tooltip || ''"
                            nzTooltipPlacement="topRight">
                            <div [ngClass]="{'error': validationErrors['orgId'] }">
                                <ppl-dropdown-select formControlName="orgId" id="orgId" [options]="mcoEntries"
                                    [optionLabel]="'orgName'" [optionValue]="'orgId'" placeholder="MCO"
                                    [attr.aria-invalid]="validationErrors['orgId'] ? 'true' : 'false'"
                                    [attr.aria-describedby]="validationErrors['orgId'] ? 'orgId-error' : null"></ppl-dropdown-select>
                            </div>
                        </div>
                        @if (validationErrors['orgId']) {
                        <span class="pl-1 error-message">{{validationErrors['orgId']}}</span>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            }
            @if(isAttrAvailable('servicecodeDetailId')){
            <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="servicecodeDetailId"
                        class="ppl-form-label">{{getAttributes('servicecodeDetailId').label}}
                        @if(getAttributes('servicecodeDetailId').mandatory === 'Y'){
                        <span [attr.aria-label]="'Required'">*</span>
                        }
                    </nz-form-label>

                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                        <div nz-tooltip [nzTooltipTitle]="getAttributes('servicecodeDetailId')?.tooltip || ''"
                            nzTooltipPlacement="topRight">
                            <div [ngClass]="{'error': validationErrors['servicecodeDetailId'] }">
                                <ppl-dropdown-select formControlName="servicecodeDetailId" id="servicecodeDetailId"
                                    [options]="serviceCodeList" [optionLabel]="'svcDesc'"
                                    [optionValue]="'servicecodeDetailId'" [placeholder]="'Service Code'" [arialabel]="getAttributes('servicecodeDetailId').mandatory === 'Y' 
                              ? 'Service Code, required' 
                              : 'Service Code'"></ppl-dropdown-select>
                            </div>
                        </div>
                        @if (validationErrors['servicecodeDetailId']) {
                        <span class="pl-1 error-message">{{validationErrors['servicecodeDetailId']}}</span>
                        }
                    </nz-form-control>

                </nz-row>
            </nz-form-item>
            }
            @if(isAttrAvailable('providerId')){
            <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="providerId"
                        class="ppl-form-label">{{getAttributes('providerId').label}}
                        @if(getAttributes('providerId').mandatory === 'Y'){
                        <span [attr.aria-label]="'Required'">*</span>
                        }
                    </nz-form-label>

                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                        <div nz-tooltip [nzTooltipTitle]="getAttributes('providerId')?.tooltip || ''"
                            nzTooltipPlacement="topRight">
                            <div [ngClass]="{'error': validationErrors['providerId'] }">
                                <ppl-dropdown-select formControlName="providerId" id="providerId"
                                    [options]="providerList" [optionLabel]="'providerName'" [optionValue]="'providerId'"
                                    [placeholder]="'Personal Assistant'" [arialabel]="getAttributes('providerId').mandatory === 'Y' 
                              ? 'PA, required' 
                              : 'PA'"></ppl-dropdown-select>
                            </div>
                        </div>
                        @if (validationErrors['providerId']) {
                        <span class="pl-1 error-message">{{validationErrors['providerId']}}</span>
                        }
                    </nz-form-control>

                </nz-row>
            </nz-form-item>
            }
            @if(isAttrAvailable('weeklyLimitHrs')){
            <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left" class="ppl-form-control">
                <nz-row>
                    <nz-form-label id="label-unitsInFormat" [nzSm]="10" [nzXs]="24" nzFor="weeklyLimitHrs"
                        class="ppl-form-label">{{getAttributes('weeklyLimitHrs').label}}
                        @if(getAttributes('weeklyLimitHrs').mandatory === 'Y'){
                        <span [attr.aria-label]="'Required'">*</span>
                        }
                    </nz-form-label>
                    <nz-form-control [nzSm]="6" [nzXs]="24"  style="margin-right: 8px;">
                        <div nz-tooltip [nzTooltipTitle]="getAttributes('weeklyLimitHrs')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                            <input nz-input type=text formControlName="weeklyLimitHrs" id="weeklyLimitHrs"
                                (input)="limitDigits($event)" placeholder="Hours" aria-autocomplete="none"
                                aria-label="Weekly Limit Hours"
                                [ngClass]="{'error': validationErrors['weeklyLimitHrs'] }"/>
                        </div>
                    </nz-form-control>
                    <nz-form-control [nzSm]="6" [nzXs]="24">
                        <div nz-tooltip [nzTooltipTitle]="getAttributes('weeklyLimitMins')?.tooltip || ''"
                            nzTooltipPlacement="topRight">
                            <div [ngClass]="{'error': validationErrors['weeklyLimitHrs'] }">
                                <ppl-dropdown-select formControlName="weeklyLimitMins" id="weeklyLimitMins"
                                    [options]="minSteps" [showArrow]="false" [showClearButton]="false"
                                    [placeholder]="'Minutes'" arialabel="Minutes required" [optionLabel]="'label'"
                                    [optionValue]="'value'"
                                    aria-label="Weekly Limit Minutes"></ppl-dropdown-select>
                            </div>
                        </div>
                    </nz-form-control>
                </nz-row>
                @if (validationErrors['weeklyLimitHrs']) {
                    <nz-row>
                      <nz-form-control [nzSm]="10" [nzXs]="24"></nz-form-control>
                      <nz-form-control [nzSm]="12" [nzXs]="24">
                        <span class="pl-1 error-message">{{validationErrors['weeklyLimitHrs']}}</span>
                      </nz-form-control>
                    </nz-row>
                  }
            </nz-form-item>
            }

            @if(isAttrAvailable('units')){
            <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="units"
                        class="ppl-form-label">{{getAttributes('units').label}}
                        @if(getAttributes('units').mandatory === 'Y'){
                        <span [attr.aria-label]="'Required'">*</span>
                        }
                    </nz-form-label>

                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                        <div nz-tooltip [nzTooltipTitle]="getAttributes('units')?.tooltip || ''"
                            nzTooltipPlacement="topRight">
                            <input nz-input formControlName="units" id="units" placeholder="Units" [readonly]="true"
                                aria-readonly="true" [ngClass]="{'error': validationErrors['units'] }" />
                        </div>
                        @if (validationErrors['units']) {
                        <span class="pl-1 error-message">{{validationErrors['units']}}</span>
                        }
                    </nz-form-control>

                </nz-row>
            </nz-form-item>
            }

            @if(isAttrAvailable('startDate')){
            <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="startDate"
                        class="ppl-form-label">{{getAttributes('startDate').label}}
                        @if(getAttributes('startDate').mandatory === 'Y'){
                        <span [attr.aria-label]="'Required'">*</span>
                        }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                        <div nz-tooltip [nzTooltipTitle]="getAttributes('startDate')?.tooltip || ''"
                            nzTooltipPlacement="topRight">
                            <ppl-date-picker formControlName="startDate" id="startDate" [showIcon]="true"
                                [placeholder]="getAttributes('startDate').placeholder" dateFormat="mm/dd/yy"
                                [ariaLabel]="getAttributes('startDate').mandatory === 'Y' 
                            ? getAttributes('startDate').label + ', required' 
                            : getAttributes('startDate').label" [readonlyInput]="true" [monthNavigator]="true"
                                [yearNavigator]="true" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
                                [minDate]="minDate" inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'"
                                [maxDate]="minStartDate"
                                [styleClass]="validationErrors['startDate'] ? 'error' : ''"></ppl-date-picker>
                        </div>
                        @if (validationErrors['startDate']) {
                        <span class="pl-1 error-message">{{validationErrors['startDate']}}</span>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            }
            @if(isAttrAvailable('endDate')){
            <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="endDate"
                        class="ppl-form-label">{{getAttributes('endDate').label}}
                        @if(getAttributes('endDate').mandatory === 'Y'){
                        <span [attr.aria-label]="'Required'">*</span>
                        }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                        <div nz-tooltip [nzTooltipTitle]="getAttributes('endDate')?.tooltip || ''"
                            nzTooltipPlacement="topRight">
                            <ppl-date-picker formControlName="endDate" id="endDate" [showIcon]="true"
                                [placeholder]="getAttributes('endDate').placeholder" dateFormat="mm/dd/yy"
                                [readonlyInput]="true" [monthNavigator]="true" [yearNavigator]="true"
                                [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="icondisplay"
                                [panelStyleClass]="'custom-calendar-panel'" [minDate]="maxEndDate" [ariaLabel]="getAttributes('endDate').mandatory === 'Y' 
                            ? getAttributes('endDate').label + ', required' 
                            : getAttributes('endDate').label"
                                [styleClass]="validationErrors['endDate'] ? 'error' : ''"></ppl-date-picker>
                        </div>
                        @if (validationErrors['endDate']) {
                        <span class="pl-1 error-message">{{validationErrors['endDate']}}</span>
                        }
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
            }
            @if(isAttrAvailable('comments')){
            <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="comments"
                        class="ppl-form-label">{{getAttributes('comments').label}}
                        @if(getAttributes('comments').mandatory === 'Y'){
                        <span [attr.aria-label]="'Required'">*</span>
                        }
                    </nz-form-label>

                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                        <div nz-tooltip [nzTooltipTitle]="getAttributes('comments')?.tooltip || ''"
                            nzTooltipPlacement="topRight">
                            <input nz-input formControlName="comments" id="comments" placeholder="Comments"
                                [ngClass]="{'error': validationErrors['comments'] }" />
                        </div>
                        @if (validationErrors['comments']) {
                        <span class="pl-1 error-message">{{validationErrors['comments']}}</span>
                        }
                    </nz-form-control>

                </nz-row>
            </nz-form-item>
            }


        </div>
    </form>
</div>
<div class="custom-row">
    <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
        (click)="cancelEdit()"></ppl-button>

    <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
        (click)="save()"></ppl-button>
</div>